var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "lib-select",
      class: { _rightAligned: _vm.rightAligned },
      on: {
        keydown: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "down", 40, $event.key, [
                "Down",
                "ArrowDown",
              ])
            ) {
              return null
            }
            return _vm.goDownOne.apply(null, arguments)
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
            ) {
              return null
            }
            return _vm.goUpOne.apply(null, arguments)
          },
          _vm.keydown,
        ],
      },
    },
    [
      _vm.autocomplete
        ? _c("input", {
            staticClass: "autocomplete",
            attrs: { tabindex: "-1", autocomplete: _vm.autocomplete },
            on: { input: _vm.fillInAutoComplete },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a",
        {
          directives: [
            {
              name: "clickaway",
              rawName: "v-clickaway",
              value: _vm.clickaway,
              expression: "clickaway",
            },
          ],
          staticClass: "selected",
          class: { open: _vm.open },
          attrs: { href: "javascript:void(0)" },
          on: {
            click: function ($event) {
              _vm.open = !_vm.open
            },
          },
        },
        [
          _vm.value !== null
            ? _vm._t(
                "selected",
                function () {
                  return [_vm._v(_vm._s(_vm.selected.description))]
                },
                { option: _vm.selected }
              )
            : _c("span", { staticClass: "_placeholder" }, [
                _vm._v(_vm._s(_vm.placeholder)),
              ]),
          _vm._v(" "),
          _vm.open
            ? _c("i", { staticClass: "fas fa-angle-up" })
            : _c("i", { staticClass: "fas fa-angle-down" }),
          _vm._v(" "),
          _vm.name
            ? _c("input", {
                attrs: {
                  type: "hidden",
                  name: _vm.name,
                  required: _vm.required,
                },
                domProps: { value: _vm.inputValue },
              })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.open
        ? _c("div", { staticClass: "options" }, [
            _vm.showSearch
              ? _c("div", { staticClass: "lib-search-field" }, [
                  _c("input", {
                    ref: "search",
                    attrs: {
                      type: "search",
                      placeholder: _vm.searchPlaceholder
                        ? _vm.searchPlaceholder
                        : "Search...",
                    },
                    domProps: { value: _vm.search },
                    on: {
                      input: _vm.debouncedSearch,
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "options-inner", attrs: { tabindex: "-1" } },
              _vm._l(_vm.filtered, function (option, index) {
                return _c(
                  "a",
                  {
                    ref: "option_" + index,
                    refInFor: true,
                    class: {
                      isSelected: _vm.options.indexOf(option) === _vm.value,
                    },
                    attrs: { href: "javascript:void(0)" },
                    on: {
                      click: function ($event) {
                        return _vm.select(option)
                      },
                      focus: function ($event) {
                        _vm.focusedIndex = index
                      },
                    },
                  },
                  [
                    _vm._t(
                      "descriptions",
                      function () {
                        return [_vm._v(_vm._s(option.description))]
                      },
                      { option: option }
                    ),
                    _vm._v(" "),
                    _vm.options.indexOf(option) === _vm.value
                      ? _c("i", { staticClass: "fa fa-check" })
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }